<template>
  <div>
    <input type="checkbox" :checked="visibleModel" class="modal-toggle">
    <div class="modal">
      <div :class="['modal-box max-w-none', width]">
        <h3 class="font-bold text-lg">{{ title }}</h3>
        <div>
          <slot />
        </div>
        <div v-if="!hideActions" class="modal-action space-x-4">
          <my-button v-if="$attrs.onSave && !readonly" type="primary" @click="handleSave" :loading="saving" icon="check">{{ saveText }}</my-button>
          <my-button @click="handleCancel" icon="x" :disabled="saving">Хаах</my-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String },
    visible: { type: Boolean, default: false },
    width: { type: String, default: 'w-1/2' },
    hideActions: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    saveText: { type: String, default: 'Хадгалах' },
    readonly: { type: Boolean, default: false }
  },
  computed: {
    visibleModel: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSave () {
      this.$emit('save')
    },
    handleCancel () {
      this.visibleModel = false
      this.$emit('cancel')
    }
  }
}
</script>
